export default {
  type: 'editor.elements.ImageElement',
  name: 'Image',
  editModeTitle: 'Edit Image',
  icon: 'M8.5,12.5L11,15.5L14.5,11L19,17H5M23,18V6A2,2 0 0,0 21,4H3A2,2 0 0,0 1,6V18A2,2 0 0,0 3,20H21A2,2 0 0,0 23,18Z',
  order: 70,
  tooltip: 'Bring your listing to life with beautiful images.',
};
